'use client';

import React from 'react';
import { Moon, Sun } from 'lucide-react';

import Tooltip from '@shaojiang/components/Tooltip';
import { IconButton } from '@shaojiang/components/ui/icon-button';
import useShaojiangTheme from '@shaojiang/hooks/useShaojiangTheme';
import { ThemeMode } from '@shaojiang/theme/modes';

export default function ThemeSwitch() {
  const { theme, setTheme } = useShaojiangTheme();

  if (!theme) {
    return null;
  }

  const isDark = theme === ThemeMode.Dark;

  return (
    <Tooltip title='Switch Theme'>
      <IconButton
        variant='ghost'
        colorPalette='gray'
        color='fg.icon'
        aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
        onClick={() => setTheme(isDark ? ThemeMode.Light : ThemeMode.Dark)}
      >
        {isDark ? <Sun /> : <Moon />}
      </IconButton>
    </Tooltip>
  );
}
